export const material_url: string = "fabricator_material";
export const sketch_material_url: string = "sketch_material";
export const sketch_color_url: string = "sketch_color";
export const fabricator_color_url: string = "fabricator_color";
